module.exports = __webpack_public_path__ + "static/media/weekend.f606b9a9.png";